export default [{
  mainButton: {
    name: 'vacancyAdd',
    label: 'Добавить',
    goTo: '?modal=vacancy-editor~-1',
    tooltip: 'Добавить новую вакансию'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersOutsourcing',
    label: 'Аутсорс<br>компании',
    tooltip: 'Фильтр вакансий по аутсорс компаниям',
    customMenuComponent: 'vacancyFiltersOutsourcing'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersWorkType',
    label: 'Типы работ',
    tooltip: 'Фильтр вакансий по типам работ',
    customMenuComponent: 'vacancyFiltersWorkType'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersFree',
    label: 'Свободные',
    tooltip: 'Фильтр вакансий по статусу: свободна/не свободна',
    menu: [{
      name: 'selectAll',
      label: 'Все вакансии',
      goTo: '?vacancyFilterFree=all'
    }, {
      name: 'vacanciesFree',
      label: 'Только свободные',
      goTo: '?vacancyFilterFree=free'
    }, {
      name: 'vacanciesNotFree',
      label: 'Только занятые',
      goTo: '?vacancyFilterFree=not-free'
    }]
  }
}, {
  mainButton: {
    name: 'vacancyFiltersApproved',
    label: 'Подтверждённые',
    tooltip: 'Фильтр вакансий по статусу: подтверждена/не подтверждена',
    menu: [{
      name: 'selectAll',
      label: 'Все вакансии',
      goTo: '?vacancyFilterApproved=all'
    }, {
      name: 'vacanciesFree',
      label: 'Только подтверждённые',
      goTo: '?vacancyFilterApproved=approved'
    }, {
      name: 'vacanciesNotFree',
      label: 'Только неподтверждённые',
      goTo: '?vacancyFilterApproved=not-approved'
    }]
  }
}, {
  mainButton: {
    name: 'includeOutsource',
    label: 'Аутсорс<br>биржа',
    tooltip: 'Включение/отключение показа вакансий из других сетей',
    goTo: '?includeOutsource=TOGGLE'
  }
}, {
  mainButton: {
    name: 'internalExchange',
    label: 'Внутренняя<br>биржа',
    tooltip: 'Включение/отключение показа вакансий внутренней биржи',
    goTo: '?internalExchange=TOGGLE'
  }
}, {
  mainButton: {
    name: 'selectInternalOrOutsources',
    label: 'Выбрать<br>от кого заявки',
    goTo: '?modal=selectInternalOrOutsources'
  }
}];